import { setupDealOfferTeaser } from './versions/dealsOfferTeaser';
import { setupExpandingTeasers } from './versions/expandingTeasers';
import { setupStripeTeasers } from './versions/stripeTeaser';
import {
  carouselMakeAll,
  setupTeaserBackgrounds,
  setUpTeaserGradient,
  locateTeasers,
  setUpThumbnailSize,
  setSlider3Behavior,
  setUpCursorsForTeasers,
  setUpHoverEffectForTeasers,
  isTouchDevice,
  touchDeviceClass,
} from '@msc-b2c/shared-utils';

function editorialTeaser() {
  //wrapper function to run all setup functions
  function onDocumentReady(): void {
    // we need to run carouselMakeAll first in order to change the dom so the rest of setup functions can apply
    carouselMakeAll();

    // Locate all teasers once and reuse them
    const {
      allTeasers,
      expandingTeasers,
      dealsTeasers,
      stripeTeasers,
      heroTeasers,
      slider3Teasers,
      dealsTeasers2,
      dealsCategoryTeasers,
      teaserSimpleCard,
      teasersPromo,
      horizontalTeasers,
    } = locateTeasers();

    setupTeaserBackgrounds(allTeasers);
    setupExpandingTeasers(expandingTeasers);
    setupExpandingTeasers(stripeTeasers);
    setupDealOfferTeaser([...dealsTeasers, ...dealsCategoryTeasers]);
    setUpTeaserGradient(allTeasers);
    setupStripeTeasers(stripeTeasers);
    setUpThumbnailSize(heroTeasers);
    setUpCursorsForTeasers(
      dealsTeasers2,
      dealsCategoryTeasers,
      teaserSimpleCard,
      teasersPromo,
      horizontalTeasers
    );
    setUpHoverEffectForTeasers(dealsCategoryTeasers);
    if (slider3Teasers) {
      setSlider3Behavior(slider3Teasers);
    }
    if (isTouchDevice()) {
      touchDeviceClass(allTeasers);
    }
  }

  if (document.readyState !== 'loading') {
    onDocumentReady();
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  }
}

editorialTeaser();
